import { TranslationsTextAreaController } from "./translations-text-area.controller";

angular
    .module("thor.shared.translations.translations-text-area.component", [])
    .component("translationsTextArea", {
        bindings: {
            rows: "<",
            cols: "<",
            model: "=",
            saveStandard: "&",
            saveTranslation: "&",
            disabled: "<",
            placeholderTextArea: "<",
            required: "<",
            ariaLabelTextArea: "<",
            minLength: "<",
            maxLength: "<",
            name: "@",
            field: "@",
            translationField: "@",
            selectedLang: "<",
            sourceLang: "<",
            onStandardKeyUp: "&",
            onTranslationKeyUp: "&"
        },
        controller: TranslationsTextAreaController,
        template: require("../../shared/translations/translations-text-area.html")
    });
